<template lang="pug">
  r-table( 
    ref='table'
    no-actions
    no-search
    v-bind='tableProps' 
    )
    template( slot='prepend' )
      v-btn( color='success' @click='submitExcel' ) reporte de comisiones &nbsp;
        v-icon cloud_download
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import SlSellerSaleCommissionFilters from '@/views/Sale/SlSellerSaleCommission/SlSellerSaleCommissionFilters'
  import SlSellerSaleCommissionHeaders from '@/views/Sale/SlSellerSaleCommission/SlSellerSaleCommissionHeaders'
  import SlSellerSaleCommissionModel from '@/models/Sale/SlSellerSaleCommission'
  import SlSellerSaleCommissionService from '@/services/api/Sale/SlSellerSaleCommission'
  //
  export default {
    components: {
      RTable,
    },
    computed: {
      tableProps() {
        return {
          filters: SlSellerSaleCommissionFilters,
          headers: SlSellerSaleCommissionHeaders,
          service: SlSellerSaleCommissionService.toList(),
        }
      },
    },
    data() {
      return {
        slSellerSaleCommission: new SlSellerSaleCommissionModel({ id: 'excel' }),
      }
    },
    methods: {
      getTableFilters() {
        //
        const { vendedor_id, fecha_min, fecha_max } = this.$refs.table.filter
        //
        return {
          filter: {
            vendedor_id, 
            fecha_min, 
            fecha_max,
          }
        }
      },
      showFile(res) {
        //console.log(res.request.getResponseHeader('content-disposition').split('filename=').pop())
        //var fileURL = URL.createObjectURL(res.data)
        //window.open(URL.createObjectURL(res.data))
        const name = res.request.getResponseHeader('content-disposition').split('filename=').pop()
        const filename = name.split('.xlsx').shift()
        this.slSellerSaleCommission.showFile(filename, 'xlsx')(res)
      },
      submitExcel() {
        this.slSellerSaleCommission.excel('', this.getTableFilters()).then(this.showFile)
      },
    },
    mounted() {
      this.setTitle('Reporte de comisión de vendedores')
    },
  }
</script>
